//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppCardCode from '@/@core/components/app-card-code/AppCardCode.vue'

// demos
import DemoFormValidationSimple from './demos/DemoFormValidationSimple.vue'
import DemoFormValidationMultipleRules from './demos/DemoFormValidationMultipleRules.vue'
import DemoFormValidationTypes from './demos/DemoFormValidationTypes.vue'

// code
import { formValidationSimple, formValidationMultipleRules, formValidationTypes } from './demos/code'

export default {
  components: {
    AppCardCode,
    DemoFormValidationSimple,
    DemoFormValidationMultipleRules,
    DemoFormValidationTypes,
  },
  setup() {
    return {
      codeSnippet: {
        formValidationSimple,
        formValidationMultipleRules,
        formValidationTypes,
      },
    }
  },
}
